export default __webpack_public_path__ + "static/media/call-center.2cb8ec14.png";